import { render } from "./Logins.vue?vue&type=template&id=6b209d94&scoped=true&ts=true"
import script from "./Logins.vue?vue&type=script&lang=ts"
export * from "./Logins.vue?vue&type=script&lang=ts"

import "./Logins.vue?vue&type=style&index=0&id=6b209d94&lang=less&scoped=true"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b209d94"]])

export default __exports__